
const checkPermissions = (userPermissions, allowedPermissions) => {

    if (allowedPermissions.length === 0) {
      return true;
    }
  return userPermissions.some(permission =>
    allowedPermissions.includes(permission.claimType+":"+permission.claimValue)
  );

    // return userPermissions.some(permission =>
    //  (allowedPermissions.some(p => ((p.claimType.toLowerCase() === permission.claimType.toLowerCase())&&
    //  (p.claimValue.toLowerCase() === permission.claimValue.toLowerCase())))===true) 
    // );
  };
  
  const AccessControl = ({
    userPermissions,
    allowedPermissions,
    children,
    renderNoAccess,
  }) => {
    const permitted = checkPermissions(userPermissions, allowedPermissions);
 
    if (permitted) {
      return children;
    }
    return renderNoAccess();
  };
  
  AccessControl.defaultProps = {
    allowedPermissions: [],
    userPermissions: [],
    renderNoAccess: () => null,
  };
  export default {checkPermissions,AccessControl};